export default __webpack_public_path__ + "static/media/about-us.c2582049.png";